<script setup lang="ts">
const props = defineProps({
  label: {
    type: String,
    required: true,
  },
  active: {
    type: Boolean,
    required: true,
  },
  uppercase: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['toggle'])

const arrowIcon = computed(() => {
  return props.active ? '-scale-y-100' : ''
})

function handleClick() {
  emit('toggle')
}
</script>

<template>
  <button
    class="font-weight-normal cursor-pointer text-sm"
    :class="{ uppercase: uppercase }"
    @click="handleClick"
  >
    <UiAnimatedUnderlineText class="mr-1 inline">
      {{ label }}
    </UiAnimatedUnderlineText>
    <IconDropdownArrow class="inline" :class="arrowIcon" />
  </button>
</template>

<style scoped></style>
